import { Component, CUSTOM_ELEMENTS_SCHEMA, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-recover-button',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './recover-button.component.html',
  styleUrls: ['./recover-button.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RecoverButtonComponent {
  public recoverPointClickEmitter = output<void>();

  public handleRecoverPointClick() {
    this.recoverPointClickEmitter.emit();
  }
}
